import { Card, CardContent, Container, Modal, Rating, TextField, Box, CircularProgress} from '@mui/material';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import IAvaliacao from '../../Interfaces/avaliacao/avaliacao.interface';
import api from '../../Services/ApiService';
import { Button, StyledButton, Title } from './styles';

const labels: { [index: string]: string } = {
  1: 'Péssima',
  2: 'Ruim',
  3: 'Ok',
  4: 'Boa',
  5: 'Excelente',
};

interface IModalAvaliacaoProps {
  opened:boolean;
  handleClose : () => void;
}
const ModalAvaliacao: React.FC<IModalAvaliacaoProps> = ({opened,handleClose}) => {
  const [nota,setNota] = useState<number>(3);
  const [hover, setHover] = React.useState(-1);
  const [chaveAgendamento,setChaveAgendamento] = useState<string>('');
  const [criticaText,setCriticaText] = useState<string>('');
  const [loading,setLoading] = useState<boolean>(false);
  // const handleClose = () => {
  //   setOpened(false);
  // }
  const handleEnviar = async (event:React.FormEvent) => {
    event.preventDefault();
    const avaliacao : IAvaliacao = {
      id:0,
      gUIDAgendamento:chaveAgendamento,
      crítica:criticaText,
      nota:nota,
      excluido:false
    }
    try {
      setLoading(true);
      await api.post('/avaliacoes',avaliacao);
      setLoading(false);
      handleClose();
      Swal.fire({
        title:'Sucesso!',
        text:'Sua avaliação foi enviada com sucesso!',
        icon: 'success'
      })
    } catch (error:any) {
      setLoading(false);
      handleClose();
      return Swal.fire({
        title:'Erro!',
        text:`${error.response.data}`,
        icon: 'error'
      })
    }
  }
  return (
    <>
      <Modal
        open={opened}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{overflow:'hidden'}}
        >
          <Container maxWidth="sm" sx={{padding:'5%'}}>
            <Card>
              <div style={{textAlign:'center'}}>
                <Title>Avaliar Sessão</Title>
              </div>
              <CardContent>
                <form onSubmit={handleEnviar}>
                  <Box
                    sx={{
                      // width: 200,
                      display: 'flex',
                      flexDirection:'column',
                      alignItems: 'center',
                      justifyContent:'center'
                    }}
                    >
                    <Rating
                      name="hover-feedback"
                      size="large"
                      value={nota}
                      onChange={(event, newValue) => {
                        newValue ? setNota(newValue) : setNota(3);
                      }}
                      onChangeActive={(event, newHover) => {
                        setHover(newHover);
                      }}
                      // emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                      />
                    {nota !== null && (
                      <Box sx={{ ml: 2, alignItems:'center' }}>{labels[hover !== -1 ? hover : nota]}</Box>
                    )}
                  </Box>
                  <div style={{margin:'20px 0px'}}></div>
                  <TextField 
                    type='text'
                    required
                    label="Chave de agendamento"
                    value={chaveAgendamento} 
                    onChange={(event)=>{setChaveAgendamento(event.target.value)}}
                    style={{width:'100%'}}
                    />
                  <div style={{margin:'20px 0px'}}></div>
                  <div style={{margin:'20px 0px'}}></div>
                  <TextField 
                    multiline
                    type='text'
                    required
                    label="Avaliação"
                    value={criticaText} 
                    onChange={(event)=>{setCriticaText(event.target.value)}}
                    style={{width:'100%'}}
                    />
                <div style={{textAlign:'center',margin:'10px'}}>
                    <StyledButton type='submit'>
                    {loading ? <CircularProgress/> : 'Enviar'}
                    </StyledButton>
                </div>
                </form>
              </CardContent>
            </Card>
          </Container>
      </Modal>
    </>
  )
}

const AvaliarAgendamento: React.FC = () => {
  const [opened,setOpened] = useState<boolean>(false);
  const handleClose = () => {
    setOpened(false);
  }
  
  return (
    <>
      <Button onClick={()=>setOpened(true)}>Avaliar Sessão</Button>
      {opened &&
        <ModalAvaliacao opened={opened} handleClose={handleClose}/>
      }
    </>
  )
}

export default AvaliarAgendamento;